import React, { useState } from "react";
import { Row, Col, Breadcrumb, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import AddTerminationModal from "../../modals/hrm/termination/AddTerminationModal";


const TerminationHeader = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
     
      >
        <Row className="align-items-center justify-content-between">
          
          {/* LEFT */}
 
<Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Termination</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      HRM
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Termination</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
          {/* RIGHT BUTTON */}
          <Col
            md={6}
            sm={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "10px",
            }}
          >
            <Button
              onClick={() => setShowModal(true)}
              style={{
                backgroundColor: "#f97316",
                border: "none",
                padding: "8px 18px",
                fontSize: "14px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontWeight: "500",
              }}
            >
              <FiPlusCircle />
              Add Termination
            </Button>
          </Col>
        </Row>
      </div>

      {/* MODAL */}
      <AddTerminationModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
};

export default TerminationHeader;